exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\np[data-v-2567d784] {\n  color: #232323;\n  font-size: 24px;\n  text-align: center;\n}\n.operator_img[data-v-2567d784] {\n  max-width: 35px;\n  margin-top: -8px;\n  margin-right: 3px;\n}\n", ""]);

// exports
